/**
 * Contact deep-link: reflect the open contact in the URL as `?contact=<id>` (plus
 * `?view=<tab>`), so a refresh or a pasted/navigated URL re-opens that contact's
 * drawer. Uses replaceState — the drawer is an overlay, not a distinct history
 * entry, so opening/closing it should not stack browser back-button steps.
 */

const CONTACT_PARAM = 'contact';
const VIEW_PARAM = 'view';
// ehr#252: Alerts Hub links add the record to open (e.g. a shared form) and the alert id. Both
// are one-shot: read on load, dropped the first time the drawer writes the URL.
const RECORD_PARAM = 'record';
const ALERT_PARAM = 'alert';

/** The contact (and optional drawer tab and record) requested by the current URL, if any. */
export function readContactParam(): { id: string; view?: string; record?: string } | null {
  const p = new URLSearchParams(window.location.search);
  const id = p.get(CONTACT_PARAM);
  if (!id) return null;
  const view = p.get(VIEW_PARAM);
  const record = p.get(RECORD_PARAM);
  return { id, ...(view ? { view } : {}), ...(record ? { record } : {}) };
}

/** Write (id set) or clear (id null) the contact deep-link on the current URL. */
export function writeContactParam(id: string | null, view?: string): void {
  const url = new URL(window.location.href);
  url.searchParams.delete(RECORD_PARAM);
  url.searchParams.delete(ALERT_PARAM);
  if (id) {
    url.searchParams.set(CONTACT_PARAM, id);
    if (view) url.searchParams.set(VIEW_PARAM, view);
    else url.searchParams.delete(VIEW_PARAM);
  } else {
    url.searchParams.delete(CONTACT_PARAM);
    url.searchParams.delete(VIEW_PARAM);
  }
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
}
